import { EventBus } from '../../../event-bus';
import { authService } from '../../services/AuthService';

const state = {
  token: localStorage.getItem('auth-token') || '',
  status: ''
};

const getters = {
  isAuthenticated: (authState) => !!authState.token,
  authStatus: (authState) => authState.status,
  authToken: (authState) => authState.token,
};

const actions = {
  authRequest: ({ commit }, credentials) => {
    return new Promise((resolve, reject) => {
      console.log('authRequest action');
      commit('authRequest');
      authService.login(credentials)
        .then(function (result) {
          console.log('authService.login done');

            localStorage.setItem('auth-token', result); // save the auth token in localStorage for persistent login
            commit('authSuccess', result);
          EventBus.$emit('logged-in', null);
          resolve(result);
        })
        .catch(function (errors) {
          console.log('authService.login error');
          commit('authError', errors);
          localStorage.removeItem('auth-token');
          reject(errors);
        });
    });
  },
  authLogout: ({ commit }) => {
    return new Promise((resolve, reject) => {
      console.log('authLogout action');
      commit('authLogout');
      localStorage.removeItem('auth-token');
      resolve();
    });
  },
};

const mutations = {
  authRequest: (authState) => {
    console.log('authRequest mutation');
    authState.status = 'attempting authentication request';
  },
  authSuccess: (authState, authToken) => {
    console.log('authSuccess mutation');
    authState.status = 'authentication succeeded';
    authState.token = authToken;
  },
  authError: (authState) => {
    console.log('authError mutation');
    authState.status = 'error';
  },
  authLogout: (authState) => {
    console.log('authLogout mutation');
    authState.token = '';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

